import { Component } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import {
  EnsembleService,
  NavigationService,
  StyleService,
} from '@jfw/angular/ecommerce/core';
import { Subscription } from 'rxjs';
import { EnsembleListingPageFiltersComponent } from '../../listing-pages/ensemble-listing-page/filters/filters.component';
import { StyleListingPageFiltersComponent } from '../../listing-pages/style-listing-page-filters/style-listing-page-filters.component';

@Component({
  selector: 'app-customize-look-filter-sidenav',
  templateUrl: './customize-look-filter.component.html',
  styleUrls: ['./customize-look-filter.component.scss'],
  imports: [
    MatIconButton,
    MatIcon,
    StyleListingPageFiltersComponent,
    EnsembleListingPageFiltersComponent,
  ],
})
export class CustomizeLookFilterSidenavComponent {
  showStylesFilters = false;
  showEnsembleFilters = false;
  subscription = new Subscription();
  constructor(
    private navigationService: NavigationService,
    private styleService: StyleService,
    private ensembleService: EnsembleService,
  ) {}

  ngOnInit(): void {
    this.subscription.add(
      this.styleService.showFilter.subscribe((value: boolean) => {
        this.showStylesFilters = value;
      }),
    );

    this.subscription.add(
      this.ensembleService.showFilter.subscribe((value: boolean) => {
        this.showEnsembleFilters = value;
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  close(): void {
    this.styleService.showFilter.next(false);
    this.ensembleService.showFilter.next(false);
    this.navigationService.showPlpNav(false);
    this.navigationService.showCustomizeLookNav(false);
  }
}
